import React from 'react';
import styled, { keyframes } from 'styled-components';
import layerLogo from './assets/layerLogo.webp';

// Definir la animación de keyframes
const shadowAnimation = keyframes`
  0% {
    filter: drop-shadow(2px 3px 7px rgba(0, 0, 0, .1));
    transform: translateX(0px) rotateX(0deg) matrix3d(
            1, 0, 0, 0,
            0, 1, 0, 0,
            0, 0, 1, 0,
            0, 0, 0, 1
    );
  }
  50% {
    filter: drop-shadow(3px 3px 16px rgba(0, 0, 0, .2));
    transform: translateX(0px) rotateX(10deg) matrix3d(
            0.9829214561476214, 0, 0, -0.00003271751695857963,
            0, 0.9962483913887495, 0, -0.000021811677972386414,
            0, 0, 1, 0,
            0, 0, 0, 1
    );
  }
  100% {
    filter: drop-shadow(2px 3px 7px rgba(0, 0, 0, .1));
    transform: translateX(0px) rotateX(0deg) matrix3d(
            1, 0, 0, 0,
            0, 1, 0, 0,
            0, 0, 1, 0,
            0, 0, 0, 1
    );
  }
`;

// Estilizar el componente de imagen
const Layer = styled.img`
  width: 20vw;
  height: auto;
  max-height: 50%;
  background-color: transparent;
  border-radius: 8px;
  margin: auto;

  // Aplicar la animación
  animation: ${shadowAnimation} 5s infinite;
  transform-origin: left top;
`;
const ContainerBox = styled.div`
width: -webkit-fill-available;
height: auto;
min-height: calc(100vh - 85px);
max-height: 95vh;
overflow-y: hidden;
max-width: calc(100vw - 84px);
gap: 16px;

display: flex;
flex-direction: row;
align-items: flex-start;
margin: 1% 16px 0px 1%;
// padding: 0% 2% 0% 2%;
background-color:#FFFFFF;
border-radius:8px;
  box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
  border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);
@media only screen and (min-width:0px) and (max-width:1100px){
  margin: 5vh 0px 0px 0px;
  max-width: calc(100vw - 0px);


}
`;
const Flag = () => {
  return (
    <ContainerBox>
 <Layer src={layerLogo} />
    </ContainerBox>
   
  );
};

export default Flag;
